module.exports = __webpack_public_path__ + "img/zz-row-eight.09d62cf6.svg";